import { path } from "ramda";
import { useSelector } from "react-redux";

const useTenantConfig = () => {
  const config = useSelector(path(["tenantReducer", "config"]));
  return config;
};

export default useTenantConfig;
